import Vue from 'vue'
import axios from 'axios'
import _get from 'lodash/get'

import { BASE_URL } from '@/config'
import store from '../store'

const askMessage = `Please ask Admin if the problem persists.`
const DefaultErrorMessage = {
  [`get:${BASE_URL}/user/auth0`]: `You don't have permissions. ${askMessage}`,
  [`get:${BASE_URL}/books/by-isbn`]: `No matches found.`,
  [`get:${BASE_URL}/books/conditions`]: `No matches found.`,
  [`get:${BASE_URL}/books/guide-prices`]: `No matches found.`,

  [`post:${BASE_URL}/check-in`]: `Failed to check-in. Try again. ${askMessage}`,
  [`delete:${BASE_URL}/check-in`]: `Failed to delete check-in item. Try again. ${askMessage}`,
  [`get:${BASE_URL}/check-in/shipment`]: `No matches found.`,
  [`get:${BASE_URL}/check-in/checkbook`]: `No matches found.`,
  [`get:${BASE_URL}/check-in/offer-items`]: `No matches found.`,
  [`post:${BASE_URL}/check-in/print`]: `Print Job failed. Try again. ${askMessage}`,
  [`post:${BASE_URL}/check-in/undo`]: `Undo Check-in failed. Try again. ${askMessage}`,

  [`get:${BASE_URL}/offer-carts`]: `No matches found.`,
  [`post:${BASE_URL}/offer-carts`]: `Failed to create an offer. Try again. ${askMessage}`,
  [`put:${BASE_URL}/offer-carts`]: `Failed to update the offer. Try again. ${askMessage}`,
  [`delete:${BASE_URL}/offer-carts`]: `Failed to delete the offer. Try again. ${askMessage}`,
  [`post:${BASE_URL}/offer-cart/complete`]: `Failed to complete the offer. Try again. ${askMessage}`,
  [`post:${BASE_URL}/offer-cart/revise`]: `Failed to revise the offer. Try again. ${askMessage}`,
  [`post:${BASE_URL}/offer-cart/upload-inventory-list`]: `Failed to upload Inventory List. Try again. ${askMessage}`,

  [`get:${BASE_URL}/offers`]: `No matches found.`,
  [`get:${BASE_URL}/offer`]: `No matches found.`,
  [`get:${BASE_URL}/offer/accept`]: `Offer process failed. Try again. ${askMessage}`,
  [`get:${BASE_URL}/offer/reject`]: `Offer process failed. Try again. ${askMessage}`,

  [`get:${BASE_URL}/offer-items`]: `No matches found.`,
  [`get:${BASE_URL}/offer-item`]: `No matches found.`,
  [`post:${BASE_URL}/offer-items`]: `Failed to create an offer. Try again. ${askMessage}`,
  [`put:${BASE_URL}/offer-items`]: `Failed to update the offer. Try again. ${askMessage}`,
  [`delete:${BASE_URL}/offer-items`]: `Failed to delete the offer. Try again. ${askMessage}`,
  [`get:${BASE_URL}/offer-items/csv`]: `Download Failed. Try again. ${askMessage}`,

  [`get:${BASE_URL}/inventory-item`]: `No matches found.`,
  [`put:${BASE_URL}/inventory-item`]: `Failed to update the inventory item. Try again. ${askMessage}`,

  [`get:${BASE_URL}/sellers`]: `No matches found.`,
  [`get:${BASE_URL}/seller`]: `No matches found.`,
  [`post:${BASE_URL}/sellers`]: `Failed to create a seller. Try again. ${askMessage}`,
  [`put:${BASE_URL}/sellers`]: `Failed to update the seller. Try again. ${askMessage}`,
  [`delete:${BASE_URL}/sellers`]: `Failed to delete the seller. Try again. ${askMessage}`,
}

function configRequestHandler(config) {
  if (store.state.error) {
    store.commit('setError', null, { root: true })
  }

  const token = store.getters['auth/getAccessToken']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

function errorRequestHandler(err) {
  return Promise.reject(err)
}

function errorResponseHandler(error) {
  // check for errorHandle config
  if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
    return Promise.reject(error)
  }

  // if has response show the error
  if (error.response) {
    if (error.response.status === 401) {
      Vue.$toast.error(error.response.data.message || 'Token has expired. Please login again.')
      store.dispatch('auth/logout')
      // if (['/', '/home'].indexOf(_get(window, ['document', 'location', 'pathname']) || '') < 0) {
      //   window.document.location.href='/';
      // }
    } else {
      Vue.$toast.error(
        error.response.data.message ||
          DefaultErrorMessage[`${error.config.method}:${error.config.url}`] ||
          `Unknown Error. ${askMessage}`
      )
      store.commit(
        'setError',
        {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
        },
        { root: true }
      )
    }
  }

  // check for errorHandle config
  if (!error.config.stopErrorPropagation) {
    return Promise.reject(error)
  }
}

// apply interceptor on request
axios.interceptors.request.use(configRequestHandler, errorRequestHandler)

// apply interceptor on response
axios.interceptors.response.use(response => response, errorResponseHandler)

export default errorResponseHandler
